import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./auth/msalConfig";

const root = ReactDOM.createRoot(document.getElementById('root'));

// @azure/msal-browser v3+ requires initialize() to be awaited before
// the app renders or any MSAL API (like loginPopup) is used.
// Without this, popup login can silently fail to close/process.
msalInstance.initialize().then(() => {
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();